export default function ScrollFrameHero() {
  return (
    <section className="relative h-screen w-full overflow-hidden bg-black font-poppins text-white">
      <video
        className="absolute inset-0 h-full w-full object-cover md:hidden"
        src="/hero-bg-mobile.mp4"
        poster="/hero-poster-mobile.jpg"
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
      />
      <video
        className="absolute inset-0 hidden h-full w-full object-cover md:block"
        src="/hero-bg.mp4"
        poster="/hero-poster.jpg"
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
      />




      {/* Top bar is rendered globally by <Navbar /> */}



      {/* Bottom gradient blur */}
      <div className="pointer-events-none absolute inset-x-0 bottom-0 h-[72%] bg-gradient-to-t from-black via-black/70 to-transparent backdrop-blur-[2px] [mask-image:linear-gradient(to_top,black,transparent)] md:h-[55%]" />



      {/* Bottom block */}
      <div className="absolute inset-x-4 bottom-24 z-10 text-center md:inset-x-auto md:right-12 md:bottom-12 md:text-right lg:right-16 lg:bottom-16 md:inline-block">
        <div className="mb-1 flex origin-bottom scale-[0.7] items-center justify-center md:mb-3 md:scale-100 md:justify-end">
          <div className="imgg"><img src="https://i.pravatar.cc/40?img=12" alt="" width="40" height="40" loading="eager" decoding="async" /></div>
          <div className="imgg"><img src="https://i.pravatar.cc/40?img=32" alt="" width="40" height="40" loading="eager" decoding="async" /></div>
          <div className="imgg"><img src="https://i.pravatar.cc/40?img=47" alt="" width="40" height="40" loading="eager" decoding="async" /></div>
          <div className="imgg"><img src="https://i.pravatar.cc/40?img=68" alt="" width="40" height="40" loading="eager" decoding="async" /></div>
          <span className="ml-3 text-[12px] text-white/80 md:ml-4 md:text-[13px]">+200 marcas acelerando</span>
        </div>
        <h2 className="font-bold leading-[1.1] tracking-tight text-[26px] md:text-[30px] md:whitespace-nowrap md:leading-tight">
          <span className="block whitespace-nowrap md:inline">Sua marca cresce.</span>{" "}
          <span className="block whitespace-nowrap md:inline">Você foca no negócio.</span>
        </h2>
        <p className="mt-3 font-normal leading-snug text-white/75 text-[11.5px] md:mt-2 md:text-[15px] md:text-white/80 w-full">
          A <strong className="text-white">Acelera Mais</strong> cuida de tudo que gera <strong className="text-white">resultado</strong>: tráfego, criativo,<br className="hidden md:inline" />
          {" "}posicionamento e operação. Do primeiro clique até a <strong className="text-white">venda fechada</strong>.
        </p>
        <div className="mt-5 flex justify-center md:mt-6 md:justify-end">
          <a href="#formulario" className="zb-group">
            <div className="zb-inner zb-shimmer">
              <span>Preencha o formulário</span>
            </div>
            <div className="zb-arrow">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12h14"></path>
                <path d="m12 5 7 7-7 7"></path>
              </svg>
            </div>
          </a>
        </div>

      </div>
    </section>
  );
}
